import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import LoadingScreen from './LoadingScreen';

// Protected route component for admin users
export const AdminProtectedRoute = () => {
  const { admin, loading } = useAdminAuth();

  // Show loading screen while checking session
  if (loading) {
    return <LoadingScreen />;
  }

  // Redirect to admin login if no admin user is authenticated
  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }

  // Render the protected admin route content
  return <Outlet />;
};

// Public only route for admin (login page)
export const AdminPublicOnlyRoute = () => {
  const { admin, loading } = useAdminAuth();

  // Show loading screen while checking session
  if (loading) {
    return <LoadingScreen />;
  }

  // Redirect to admin dashboard if already logged in
  if (admin) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  // Render the public admin route content
  return <Outlet />;
};